import FrontPage from './FrontPage'

export default FrontPage


// WEBPACK FOOTER //
// ./src/components/FrontPage/index.js